import {
  FlowsMoveAcquisitionPrivateSwitchConsumptionViewModel,
  PostalCodeGridAreaElementViewModel,
} from "@vattenfall/self-service";

export class FlowsMoveAcquisitionPrivateSwitchModel implements PostalCodeGridAreaElementViewModel {
  /**
   * The element's lifecycle event states
   */
  state?:
    | "loading-postalcode"
    | "loading-gridarea"
    | "loading-consumption"
    | "errorred"
    | "submitted"
    | "completed"
    | null;
  /**
   * The element's errors
   */
  error?: "fetch-postalcode" | "fetch-gridarea" | "fetch-consumption";
  /**
   * The URL to redirect to upon a successful form submission
   */
  redirectUrl?: string | null;
  /**
   * Type of accomodation to estimate consumption from
   * example: 'villa', 'appartment'
   */
  buildingType?: string | null;
  /**
   * Postal code
   */
  postalCode?: string | null;
  /**
   * Postal town
   */
  postalTown?: string | null;
  /**
   * Full name of grid area. This is retrieved from the area code (3 chars).
   */
  gridArea?: string | null;
  /**
   * Energy area - 3 letters code indicating which energy area belongs the given postal code.
   */
  energyArea?: null | string;
  /**
   * The estimated consumption expressed in kWh per year
   */
  estimatedKwhConsumption?: number | null;
  /**
   * Whether the postal code id located between two grid areas
   */
  isBetweenGridAreas?: boolean | null;
  /**
   * Whether the custom is moving to a new apartment
   */
  isMoving?: boolean | null;
  /**
   * Area to use when estimating consumption for accomodation
   */
  livingArea?: number[];
  /**
   * List of area-energy units
   */
  annualEstimatedConsumption?: FlowsMoveAcquisitionPrivateSwitchConsumptionViewModel[] | null;
}
